
import Columns from '@/components/Columns';
import Column from '@/components/Column';
import Button from '@/components/Button';
import Text from '@/components/Text';
import './styles.css';
import { useErrorStore } from '@/store/error';

const ErrorAlert: React.FC = () => {
  const closeModalError = useErrorStore((store) => store.closeModal);
  const messageError = useErrorStore((store) => store.message);
  const isVisibleModalError = useErrorStore((store) => store.isVisibleModal);

  return (
    <div
      className={`alert-error-container flex items-center justify-center ${
        isVisibleModalError ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <Columns
        as='aside'
        className='mx-6 flex flex-col items-center justify-center rounded-lg bg-white p-5 lg:m-0'
        useNegativeMargin={false}
      >
        <Text as='h1' kind='blue' size='2xl' className='font-bold'>
          Problema na venda
        </Text>
        <Column className='itens-center flex flex-col justify-between'>
          <Text as='h3' kind='gray' size='base' className='p-2 text-center'>
            {messageError}
          </Text>
          <Column className='px-5 pt-2'>
            <Button kind='primary' large onClick={() => closeModalError()}>
              Entendi
            </Button>
          </Column>
        </Column>
      </Columns>
    </div>
  );
};

export default ErrorAlert;
